export const referrals = {
  menu: {
    label: "Parrainez et gagnez",
    badge: "Gagnez",
  },
  welcomeCard: {
    title: "Votre abonnement peut devenir gratuit",
    desc: "Invitez d'autres hôtes et gagnez une part de tout ce qu'ils paient, pour toujours.",
  },
  page: {
    loading: "Chargement de vos parrainages…",
    previewNotice: "Aperçu avec des données d'exemple. Vos vrais parrainages apparaîtront ici dès que le programme sera actif.",
  },
  hero: {
    title: "Invitez d'autres hôtes et utilisez WACheckin gratuitement",
    subtitle: "Pour chaque hôte qui s'abonne avec votre lien, vous gagnez {percent} % de tout ce qu'il paie, chaque mois et pour toujours. Votre filleul commence avec {friendPercent} % de réduction.",
    personal: "Votre abonnement coûte {price} par mois. Avec {count} filleuls comme vous, vous ne payez plus rien.",
    personalGeneric: "Avec {count} hôtes comme vous qui paient, votre abonnement devient gratuit.",
  },
  rewards: {
    youGet: "Vous recevez",
    youGetBig: "{percent} % de chaque paiement",
    youGetSmall: "de chaque hôte invité, chaque mois et pour toujours",
    friendGets: "Votre filleul reçoit",
    friendGetsBig: "{percent} % de réduction",
    friendGetsSmall: "pendant ses {months} premiers mois",
    example: "Si vous invitez un hôte avec {units} appartements, vous gagnez environ {amount} par an tant qu'il reste avec nous.",
  },
  welcomeOffer: {
    title: "Votre cadeau de bienvenue",
    text: "{name} vous a invité sur WACheckin : vous bénéficiez de {percent} % de réduction sur vos {months} premiers mois. Elle s'applique lors de votre abonnement.",
  },
  share: {
    title: "Votre lien d'invitation",
    codeLabel: "Votre code",
    copy: "Copier le lien",
    copied: "Copié",
    whatsapp: "WhatsApp",
    invite: "Envoyer par e-mail",
    more: "Plus",
    message: "Je vous recommande WACheckin : je l'utilise pour le check-in en ligne, les messages aux voyageurs et pour connecter Booking et Airbnb, et cela me fait gagner beaucoup de temps. Avec mon lien, vous avez {percent} % de réduction pendant vos {months} premiers mois : {link}",
    emailSubject: "{percent} % de réduction sur WACheckin avec mon lien",
  },
  invite: {
    title: "Inviter par e-mail",
    subtitle: "Nous enverrons à votre confrère une invitation personnelle avec votre lien et sa réduction de {percent} %.",
    emailLabel: "E-mail de votre confrère",
    emailPlaceholder: "nom@entreprise.com",
    languageLabel: "Langue de l'e-mail",
    cancel: "Annuler",
    send: "Envoyer l'invitation",
    sending: "Envoi…",
    successTitle: "Invitation envoyée !",
    successDesc: "Nous avons envoyé votre invitation à {email}.",
    another: "Inviter un autre confrère",
    close: "Fermer",
    errors: {
      invalidEmail: "Saisissez une adresse e-mail valide.",
      selfInvite: "Vous ne pouvez pas envoyer l'invitation à votre propre adresse.",
      alreadyInvited: "Vous avez déjà invité cette adresse récemment. Vous pourrez réessayer dans quelques jours.",
      dailyLimit: "Vous avez atteint la limite d'invitations pour aujourd'hui. Réessayez demain.",
      tooFast: "Trop de tentatives d'affilée. Attendez une minute et réessayez.",
      generic: "Impossible d'envoyer l'invitation. Veuillez réessayer.",
    },
  },
  message: {
    title: "Message prêt à partager",
    hint: "Collez-le dans vos groupes d'hôtes, forums ou réseaux sociaux. Il fonctionne mieux avec une phrase de vous.",
    copy: "Copier le message",
  },
  how: {
    title: "Comment ça marche",
    stepLabel: "Étape {n}",
    step1Title: "Partagez votre lien",
    step1Desc: "Par WhatsApp, e-mail ou dans vos groupes d'hôtes.",
    step2Title: "Votre filleul s'abonne avec une réduction",
    step2Desc: "Il s'inscrit avec votre lien et commence avec {percent} % de réduction.",
    step3Title: "Vous gagnez chaque mois",
    step3Desc: "{percent} % de chaque paiement devient votre crédit, pour toujours. Le premier compte après {days} jours.",
  },
  results: {
    title: "Vos résultats",
    celebrate: "Vous avez déjà gagné {amount}.",
    coverage: "Vos filleuls couvrent déjà {percent} % de votre abonnement",
    coverageFree: "Votre abonnement est déjà gratuit",
    coverageHint: "Votre abonnement coûte {price} par mois et vos filleuls vous rapportent {earning} par mois.",
  },
  stats: {
    invited: "Invités",
    subscribed: "Abonnés",
    monthlyEarning: "Gains par mois",
    creditAvailable: "Crédit disponible",
    creditEarned: "{amount} gagnés au total",
    creditHint: "Déduit automatiquement de votre prochaine facture",
  },
  list: {
    title: "Vos parrainages",
    colName: "Compte",
    colDate: "Inscription",
    colStatus: "Statut",
    colReward: "Vos gains",
    empty: "Vous n'avez encore invité personne. Le premier hôte qui s'abonne avec votre lien vous rapporte déjà du crédit chaque mois.",
  },
  status: {
    registered: "Inscrit",
    subscribed: "Abonné",
    rewarded: "Actif",
    canceled: "Résilié",
    rejected: "Non éligible",
  },
  reward: {
    waiting: "En attente de son premier paiement",
    startsOn: "Vous commencez à gagner le {date}",
    earning: "{monthly} par mois, {earned} au total",
    earningNoPlan: "{earned} au total",
    canceled: "{earned} gagnés",
  },
  reasons: {
    duplicate: "Compte en double",
    selfReferral: "Auto-parrainage",
  },
  faq: {
    title: "Questions fréquentes",
    howMuchQ: "Combien je gagne ?",
    howMuchA: "{percent} % de tout ce que paie chaque hôte que vous invitez (hors taxes), chaque mois et pour toujours, sans limite de filleuls. S'il paie {price} par mois, vous gagnez environ {amount} chaque mois.",
    whenQ: "Quand vais-je le recevoir ?",
    whenA: "Chaque fois que votre filleul paie, le montant s'ajoute automatiquement à votre crédit. Son premier paiement compte après {days} jours, au cas où il résilierait juste après s'être abonné.",
    whereQ: "Où le crédit est-il utilisé ?",
    whereA: "Il est déduit automatiquement de vos prochaines factures WACheckin. Si vous n'êtes pas encore abonné, il s'applique à votre première facture.",
    limitQ: "Y a-t-il une limite ?",
    limitA: "Il n'y a pas de limite de filleuls ni de durée. La seule : le crédit accumulé et non utilisé plafonne à {months} mois de votre abonnement. Tant que vous êtes à ce plafond, votre abonnement reste gratuit ; ce qui dépasse ne s'accumule pas.",
    stopQ: "Quand est-ce que j'arrête de gagner ?",
    stopA: "Si votre filleul résilie, vous arrêtez de gagner grâce à lui. Si vous résiliez, vous arrêtez d'accumuler du crédit.",
    whoQ: "Qui puis-je inviter ?",
    whoA: "Tout hôte ou hôtel qui n'utilise pas encore WACheckin. L'auto-parrainage et les comptes en double ne sont pas éligibles.",
  },
};
